import { useMemo } from 'react';
import dict from '../i18n/engine.json';
import { createT } from '../i18n/createT';

/**
 * Traducteur de /engine (« Notre IA »).
 *
 * Ce hook portait sa propre copie de `lookup` / `interpolate` / résolution
 * de langue, avec deux particularités qui se voyaient à l'écran :
 *
 *  · `SUPPORTED = ['en', 'fr']` — le néerlandais n'existait pas, et le
 *    repli était l'ANGLAIS. Un visiteur qui cliquait NL sur une page du
 *    menu principal recevait 234 blocs de texte en anglais. Le
 *    dictionnaire `nl` existe désormais (219 clés, traduites depuis le
 *    français), et il n'y a plus de langue non couverte.
 *  · le repli anglais lui-même : partout ailleurs dans le repo, la langue
 *    de repli est le FRANÇAIS — c'est le texte validé, et le seul marché
 *    actif est belge. `createT` applique cette règle.
 *
 * Les CHIFFRES de la page (2,5 M, 97 %, < 200 ms…) ne sont pas dans le
 * dictionnaire quand ils sont identiques partout : ils vivent dans les
 * composants.
 */
export function useEngineT(language) {
  return useMemo(() => createT(dict, language), [language]);
}

export default useEngineT;
